import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import * as api from '@ubeya/shared/services/api';
import { HELP_DESK_TICKETS_QUERY_KEY } from '@ubeya/shared/hooks/account/useHelpDeskTickets';
import { getHelpDeskTicketQueryKey } from '@ubeya/shared/hooks/account/useHelpDeskTicket';
import { HELP_DESK_UNREAD_COUNT_QUERY_KEY } from '@ubeya/shared/hooks/account/useHelpDeskUnreadCount';
import { HELP_DESK_EMPLOYEE_TICKETS_QUERY_KEY } from '@ubeya/shared/hooks/account/useHelpDeskEmployeeTickets';

/**
 * Marks a help desk ticket as read on mount and invalidates the ticket caches so unread
 * badges are cleared. Runs once per ticket - a ticket marked unread while open stays unread.
 *
 * @param {{ accountId: string|number, ticketId: string|number }} options
 */
const useMarkAsRead = ({ accountId, ticketId }) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!ticketId || !accountId) return;
    api
      .updateHelpDeskTicket({ accountId, ticketId, lastReadAt: new Date().toISOString() })
      .then(() => {
        queryClient.invalidateQueries(getHelpDeskTicketQueryKey(accountId, ticketId));
        queryClient.invalidateQueries({
          predicate: (query) => Array.isArray(query.queryKey) && query.queryKey[0] === HELP_DESK_TICKETS_QUERY_KEY
        });
        queryClient.invalidateQueries({
          predicate: (query) => Array.isArray(query.queryKey) && query.queryKey[0] === HELP_DESK_UNREAD_COUNT_QUERY_KEY
        });
        queryClient.invalidateQueries({
          predicate: (query) =>
            Array.isArray(query.queryKey) && query.queryKey[0] === HELP_DESK_EMPLOYEE_TICKETS_QUERY_KEY
        });
      })
      .catch(() => {});
  }, [accountId, ticketId, queryClient]);
};

export default useMarkAsRead;
